import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/SolfaName/editor/solfanameeditor.tsx",
    () => import("./solfanameeditor"),
);
